<template lang="html">
  <div id="profile-photo-upload-form">
    <server-form
      v-slot="slotProps"
      ref="form"
      :display-save-btn="false"
      :form-action="formAction"
      :form="form"
      enctype="multipart/form-data">
      <input
        ref="profilePicture"
        :generic-error-msg="__('feedback_account_photo')"
        type="file"
        name="profile_picture"
        style="display: none;"
        accept="image/*"
        @change="handleImageChange">
    </server-form>
    <button
      :title="__('btn_choose_image')"
      :alt="__('btn_choose_image')"
      :aria-label="__('btn_choose_image')"
      class="btn btn-primary mb-3"
      @click="openFileSelect">
      {{ __('btn_choose_image') }}
      <i
        ref="defaultUploadIcon"
        :class="{ 'far fa-fw': true, 'fa-upload fa-fw': !uploading, 'fa-spinner fa-spin': uploading }" />
    </button>
    <p class="text-fade">{{ __('feedback_account_photo_limits') }}</p>
  </div>
</template>
<script>
import formAction from '../mixins/formAction'

export default {
  name: 'UserProfilePicture',

  mixins: [formAction],

  data () {
    return {
      form: {},
      uploading: false
    }
  },

  methods: {
    openFileSelect () {
      this.$refs.profilePicture.click()
    },

    handleImageChange () {
      this.uploading = true
      this.$refs.form.submit()
    }
  }
}
</script>
